<template>
  <list :moduleIdentifier="identifier" :listTitle="$t(`${identifier}.attributes.label`)" filter-title="Filtros" :loading="loadingAttributes || loadingCategories" :typesListAvailable="['displayList']" :total="total" :sortFields="['label']" :sortDefault="{ field: 'label', order: 'desc' }" @change="onChange" @clearFilters="clearFilters">
    <div slot="header-actions">
      <button class="btn btn--info" @click="addAttribute"><i class="fa fa-plus"></i></button>
    </div>

    <template slot="filters">
      <form-group label="Nome" :columns="6">
        <input type="text" v-model="options.label" class="form-input">
      </form-group>

      <form-group label="Categorias" :columns="6">
        <multiselect
          v-model="categoriesSelect"
          :options="marketplaceCategories"
          label="label"
          track-by="code"
          selectLabel=""
          selectedLabel=""
          :multiple="true"
          placeholder="Todas"
        />
      </form-group>
    </template>

    <div class="l-col-12@md" v-for="attribute in attributes" :key="attribute">
      <attribute-card :identifier="identifier" :attribute="attribute"/>
    </div>
  </list>
</template>

<script>
  import { mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { merge, cloneDeep } from 'lodash'
  import api from '@/api'
  import notifier from '@/notifier'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import VueTagsInput from '@johmun/vue-tags-input'
  import List from '@/components/shared/list/Paginator'
  import AttributeCard from '@/components/MarketplaceAttribute/AttributeCard'

  export default {
    data: () => ({
      categoriesSelect: [],
      loadingAttributes: false,
      loadingCategories: false,
      marketplaceCategories: [],
      options: {
        label: '',
        categories: ''
      },
      savingAttribute: false,
      typeSelectionOptions: [
        'select',
        'text',
        'multipleSelect'
      ]
    }),
    props: {
      identifier: {
        type: String,
        required: true
      }
    },
    mounted () {
      this.clearAttributes()
      this.getCategories()
    },
    methods: {
      ...mapActions('marketplaceAttribute', [
        'clearAttributes',
        'fetchAttributes'
      ]),
      addAttribute () {
        this.$router.push(`/marketplace/${this.identifier}/attributes/create`)
      },
      getCategories () {
        this.loadingCategories = true
        api.getCategories('marketplace', this.identifier)
          .then(categories => { this.marketplaceCategories = categories })
          .catch(() => {
            notifier.error('Erro ao buscar as categorias do marketplace.', 'Erro')
          })
          .finally(() => { this.loadingCategories = false })
      },
      onChange (options) {
        this.loadingAttributes = true

        merge(this.options, options)

        const optionsCloned = cloneDeep(this.options)

        if (this.categoriesSelect.length) {
          optionsCloned.categories = this.categoriesSelect.map(category => category.code).join(',')
        }

        this.fetchAttributes({ identifier: this.identifier, options: optionsCloned })
          .then(() => {})
          .catch(() => {})
          .finally(() => { this.loadingAttributes = false })
      },
      clearFilters () {
        this.categoriesSelect = []
      }
    },
    computed: {
      ...mapFields({
        attributes: 'marketplaceAttribute.attributes',
        total: 'marketplaceAttribute.total'
      })
    },
    components: {
      Panel,
      FormGroup,
      Multiselect,
      VueTagsInput,
      List,
      AttributeCard
    }
  }
</script>

<style lang="sass" scoped>
  .vue-tags-input
    max-width: 0
</style>



// WEBPACK FOOTER //
// List.vue?2c17c252